import React, { Component } from 'react';

import FormSimpleModal from 'zoomforth_component_lib/form_simple_modal.jsx';
import InputContainer from 'zoomforth_component_lib/input_container.jsx';
import TextareaAutosize from 'zoomforth_component_lib/textarea_autosize.jsx';

class RequestApprovalMessageModal extends Component { 

  constructor(props) {
    super(props);
    this.state = {
      message: ''
    };
  }

  render() {

    const {
      onCancel, 
      onConfirm, 
      ...props 
    } = this.props;

    const { message } = this.state;

    return (
      <FormSimpleModal className="request-approval-message-modal"
        style={{width:'500px'}}
        title="Request to Publish Site"
        cancelText="Cancel"
        confirmText="Send Request"
        onCancel={onCancel}
        onConfirm={()=> { onConfirm(this.state.message); }}
        {...props} >

        <InputContainer 
          style={{marginBottom:'5px'}}
          name="Publish Request Message"
          descriptionText={`You don't have permission to publish this site. You are requesting 
            that someone who does: review your changes, approve them, and publish the site. 
            Please include a message which will help them understand 
            the changes you've made.`} >

          <TextareaAutosize 
            value={message}
            rows={4}
            onChange={(e)=> { this.setState({ message:e.target.value }); }}
          />
          
        </InputContainer>
      </FormSimpleModal>
    );

  }
}


export default RequestApprovalMessageModal;
